import useSWR from 'swr'
import { API_URL, COLLECTIONS_VERSION } from '@/utils/constants'
import { fetcher } from '@/utils/fetcher'

// Share one bounded feed between header prewarming and the open search dialog.
// It supplies instant popular-collection matches as well as volume ranking.
export default function useSearchCollections(enabled = true) {
	return useSWR(
		enabled ? `${API_URL}/${COLLECTIONS_VERSION}?limit=200&order=VolumeTotalDesc` : null,
		fetcher,
		{ dedupingInterval: 300_000, revalidateOnFocus: false }
	)
}
